import TopSection from "../components/topSection";
import BG from "../assets/contact_bg.png";
import "../styles/contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import ContactForm from "../components/contact_form";

function COntact() {
  return (
    <>
      <TopSection image={BG} text={"Contact"}  backgroundPositionY={"-1px"}  />
      <section className="light-bg py-5">
        <div className="container  py-5">
          <div className="row">
            <div className="col-md-3 col-6 p-4">
              <div className="icon_div ratio-md-1x1">
                <div>
                  <div className="icon mx-auto">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div className="contact_div_header">Phone</div>
                  <div className="contact_div_text text-center mt-md-4">
                    +94 (0) 11 406 3290
                    <br />
                    +94 (0) 77 406 0363
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-6 p-4">
              <div className="icon_div">
                <div>
                  <div className="icon mx-auto">
                    <FontAwesomeIcon icon={faLocationDot} />
                  </div>
                  <div className="contact_div_header">Address</div>
                  <div className="contact_div_text text-center mt-md-4">
                    Brief, Kalawila Village,
                    <br /> Beruwala, 12070.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-6 p-4">
              <div className="icon_div">
                <div>
                  <div className="icon mx-auto">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="contact_div_header">Email</div>
                  <div className="contact_div_text text-center mt-md-4">
                    info@briefgarden.com
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-6 p-4">
              <div className="icon_div">
                <div>
                  <div className="icon mx-auto">
                    <FontAwesomeIcon icon={faUserCheck} />
                  </div>
                  <div className="contact_div_header">Follow Us </div>
                  <div className="contact_div_text text-center mt-md-4">
                    instagram.com/brief_garden <br />
                    facebook.com/brief_garden
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-5">
          <div className="row">
            <div className="col-md-6 col-12">
              <ContactForm />
            </div>
            <div className="col-md-6 col-12 mt-5 mt-md-0" >
             <div style={{ borderRadius: "20px",overflow: "hidden" ,height: "100%"}}>
  <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4702.692181816159!2d80.037736!3d6.45702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22dbe59b3bf0f%3A0xde956831e0d8d98b!2sBrief%20Garden%2C%20by%20Bevis%20Bawa!5e1!3m2!1sen!2slk!4v1754326274200!5m2!1sen!2slk"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Brief Garden, by Bevis Bawa Map"
              ></iframe>
             </div>
              
            </div>
          </div>
        </div>
      </section>
      

    </>
  );
}
export default COntact;
